// extracted by mini-css-extract-plugin
module.exports = {"compcont":"NewCompany_compcont__NaANq","newsurvbtn":"NewCompany_newsurvbtn__10EwH"};